// src/services/api/supplier.js
import { apiClient } from './base';

/**
 * Get all suppliers with filters
 * @param {Object} params - Query parameters
 */
export const getAllSuppliers = async (params = {}) => {
  try {
    const response = await apiClient.get('/procurement/suppliers', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get supplier by ID
 * @param {number} supplierId - Supplier ID
 */
export const getSupplierById = async (supplierId) => {
  try {
    const response = await apiClient.get(`/procurement/suppliers/${supplierId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Create a new supplier
 * @param {Object} supplierData - Supplier data
 */
export const createSupplier = async (supplierData) => {
  try {
    const response = await apiClient.post('/procurement/suppliers', supplierData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update existing supplier
 * @param {number} supplierId - Supplier ID
 * @param {Object} supplierData - Updated supplier data
 */
export const updateSupplier = async (supplierId, supplierData) => {
  try {
    const response = await apiClient.put(`/procurement/suppliers/${supplierId}`, supplierData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete supplier
 * @param {number} supplierId - Supplier ID
 */
export const deleteSupplier = async (supplierId) => {
  try {
    const response = await apiClient.delete(`/procurement/suppliers/${supplierId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get supplier statistics
 */
export const getSupplierStatistics = async () => {
  try {
    const response = await apiClient.get('/procurement/suppliers/statistics/summary');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Search suppliers by name
 * @param {string} searchTerm - Search term
 * @param {Object} options - Additional options
 */
export const searchSuppliers = async (searchTerm, options = {}) => {
  try {
    const params = {
      search: searchTerm,
      limit: options.limit || 10,
      page: options.page || 1,
      isActive: true, // Only return active suppliers
      ...options
    };
    const response = await apiClient.get('/procurement/suppliers', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};